module.exports = __webpack_public_path__ + "t_workstyle_concierge.png?cd015364d64f4ac3330ae82fa197afb5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/t_workstyle_concierge.png
// module id = 842
// module chunks = 0